import { CircularProgress, Dialog, DialogTitle } from '@mui/material';
import React, { FunctionComponent } from 'react';

interface Props {
  message: string;
  open: boolean;
  title: string;
}

const LoadingDialog: FunctionComponent<Props> = ({ open, message, title }) => (
  <Dialog open={open}>
    <DialogTitle>{title}</DialogTitle>
    <div className="flex flex-col items-center justify-center space-y-4 p-4">
      <CircularProgress size={26} />
      <p>{message}</p>
    </div>
  </Dialog>
);

export { LoadingDialog };
